/* eslint-disable */
import axios from "axios";
import auth from "services/auth";
import {
  API_URL,
  FINANCIAL_API_URL,
  API_FINANCEIRO_NAME,
  MDC_API_URL,
  API_MDC_NAME
} from "utils/constants";

const getApi = apiName => {
  switch (apiName) {
    case API_FINANCEIRO_NAME:
      return FINANCIAL_API_URL;
    case API_MDC_NAME:
      return MDC_API_URL;
    default:
      return API_URL;
  }
};

export const getToken = async () => {
  const user = await auth.getUser();
  if (user && user.access_token) {
    return user.access_token;
  }
  return undefined;
};

export const axiosInstance = async (defaultTokenParam, apiName) => {
  let defaultToken = defaultTokenParam;

  if (!defaultToken) defaultToken = await getToken();

  if (defaultToken) {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${defaultToken}`,
      "Cache-Control": "no-cache"
    };
  }

  const baseURL = getApi(apiName);
  const instance = axios.create({
    baseURL,
    timeout: 60000
  });

  instance.interceptors.response.use(
      response => response,
      async error => {
        const originalRequest = error.config;
        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry
        ) {
          originalRequest._retry = true;
          try {
            const user = await auth.getUser();
            if (user && user.isSoftauth && (user.va || user.ec)) {
              const newUser = await auth.renewSoftAuth();
              if (newUser && newUser.access_token) {
                originalRequest.headers.Authorization = `Bearer ${newUser.access_token}`;
                return instance(originalRequest);
              }
            }
          } catch (renewError) {
            return Promise.reject(renewError);
          }
        } else if (error.response &&
            error.response.status === 423) {
          const {
            response: { data }
          } = error;
          if (data) {
            window.localStorage.setItem('dataErroCriFlex', JSON.stringify(data));
            window.location.href = '/financeiro/erro-criflex';
          }
        }
        return Promise.reject(error);
      }
  );

  return instance;
};
